import type { PropsWithChildren } from "react";

import { cn } from "shared/utils/cn";

type Props = {
  type?: "default" | "danger" | "info";
  className?: string;
};

export const Notification = (props: PropsWithChildren<Props>) => {
  const { className, type = "default", children } = props;
  return (
    <div
      className={cn(
        "flex flex-col rounded-xl border px-4 py-3",
        type === "default" && "border-dark-grey bg-oil text-white",
        type === "danger" && "bg-pale-red/12 text-pale-red border-pale-red",
        type === "info" && "bg-pale-grey/12 border-pale-grey text-white",
        className
      )}
    >
      {children}
    </div>
  );
};
